import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isValidBusinessProperties } from '../../entities/BusinessProperties';
import { BaseClient } from '../BaseClient';
export class BusinessPropertiesClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createBusinessPropertiesImpl", void 0);
    _defineProperty(this, "getMyBusinessPropertiesImpl", void 0);
    _defineProperty(this, "updateBusinessPropertiesImpl", void 0);
  }
  async createBusinessProperties(businessProperties) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        businessProperties: createdBusinessProperties
      } = await this.request(this.createBusinessPropertiesImpl({
        businessProperties
      }), ...args);
      if (!createdBusinessProperties) {
        throw new Error("Can't create businessProperties");
      }
      return this.convertToEntity(createdBusinessProperties);
    } catch (error) {
      this.logError('createBusiness', 'Failed to create business properties', {
        businessProperties
      }, error);
      throw error;
    }
  }
  async getBusinessProperties() {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      const {
        businessProperties
      } = await this.request(this.getMyBusinessPropertiesImpl({}), ...args);
      this.logInfo('getBusinessProperties', 'after getMyBusinessProperties request', {
        businessProperties
      });
      if (!businessProperties) {
        throw new Error('empty businessProperties');
      }
      return this.convertToEntity(businessProperties);
    } catch (error) {
      this.logError('getBusinessProperties', 'Failed to get business properties', {}, error);
      throw error;
    }
  }
  async updateBusinessProperties(businessProperties) {
    try {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      const {
        businessProperties: updatedBusinessProperties
      } = await this.request(this.updateBusinessPropertiesImpl({
        businessProperties,
        fieldMask: ['themeColors.primary', 'themeColors.secondary', 'contextEnrichments', 'schedulingHours', 'schedulingGuidelines', 'contactHours', 'sendRemindersBeforeScheduledMeetings', 'autoRecurringServices', 'waitlist']
      }), ...args);
      if (!updatedBusinessProperties) {
        throw new Error("Can't update businessProperties");
      }
      return this.convertToEntity(updatedBusinessProperties);
    } catch (error) {
      this.logError('updateBusinessProperties', 'Failed to update business properties', {
        businessProperties
      }, error);
      throw error;
    }
  }
  convertToEntity(businessProperties) {
    this.logInfo('convertToEntity', 'start converting to entity', {
      businessProperties
    });
    try {
      if (!businessProperties) {
        throw new Error('Invalid businessProperties', {
          cause: {
            businessProperties
          }
        });
      }
      if (isValidBusinessProperties(businessProperties)) {
        return businessProperties;
      }
      throw new Error('Invalid business properties', {
        cause: {
          businessProperties
        }
      });
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert business properties', {
        businessProperties
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'BusinessPropertiesClient';
  }
}
//# sourceMappingURL=BusinessPropertiesClientBase.js.map